import { api, cachedRequest } from '../apiClient';
import { apiCache } from '../cache';

export const themeService = {
  setTheme: async (theme: 'light' | 'dark'): Promise<{ theme: string; message: string }> => {
    const response = await api.post('/theme/set/', {
      theme: theme
    });
    
    return response.data;
  },
  
  getCurrentTheme: async (forceRefresh: boolean = false): Promise<{ theme: string }> => {
    return cachedRequest(
      'current_theme_data',
      async () => {
        const response = await api.get('/theme/current/');
        return response.data;
      },
      5 * 60 * 1000, // 5 minutes
      forceRefresh
    );
  }
};

